import React, { useState } from 'react';
import { Button, Divider, Form, Input, Modal, Space, Typography  } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '@/core/store';
const { Text } = Typography;


const PasswordResetForm = ({ open, handleClose }) => {
	const [ pending, setPending ] = useState(false),
		  [ form ]                = Form.useForm(),
          dispatch                = useDispatch(),
          expiredCode             = useSelector(state => state.auth.expiredCode),
          resetPasswordModal      = useSelector(state => state.auth.loadResetPasswordModal);


	const handleSubmitEmail = async (values) => {
		setPending(true);

		try {
            dispatch(actions.auth.submitEmail(values.email));
			setPending(false);
		} catch(err) {
			setPending(false);
			console.error(err);
		}
	};

    const handleSubmitResetForm = async (values) => {
		setPending(true);

		try {
            dispatch(actions.auth.resetPassword(values.email, values.password, values.code));
			setPending(false);
		} catch(err) {
			setPending(false);
			console.error(err);
		}
	};



	const closeModal = () => {
		if(pending) {
			return false;
		}
        dispatch(actions.auth.setState({loadSubmitEmailModal: false, loadResetPasswordModal: false}));
		form.resetFields();
		handleClose();
	};



	return (<>
        <Modal
            title={'Request to reset password'}
            open={open}
            centered
            onCancel={closeModal}
            mask={{ closable: false }}
            footer={null}
        >
            <Text>A code will be sent to your email to reset your password.</Text>
            <Form
                className="ts_form_margin"
                name="submit_email"
                form={form}
                onFinish={handleSubmitEmail}
            >
                <Space.Compact block>
                    <Input value="Email" disabled style={{ width: 100 }} />
                    <Form.Item
                        name="email"
                        rules={[ { required: true, message: 'Email is required' } ]}
                        noStyle
                    >
                        <Input className="ts_padding" disabled={pending} />
                    </Form.Item>
                </Space.Compact>

                <Divider />

                <Button
                    type="primary"
                    htmlType="submit"
                    className="ts_margin_left"
                    disabled={pending}
                >
                    Submit
                </Button>

                <Button
                    onClick={closeModal}
                    className="ts_margin_left"
                    disabled={pending}
                >
                    Cancel
                </Button>

            </Form>
        </Modal>
        { resetPasswordModal && 
            <Modal
                title={'Reset Password'}
                open={resetPasswordModal}
                centered
                onCancel={closeModal}
                mask={{ closable: false }}
                footer={null}
            >
                <Text>Please check your email for the code.</Text>
                <Form
                    className="ts_form_margin"
                    name="submit_email"
                    form={form}
                    onFinish={handleSubmitResetForm}
                >
                    <Space.Compact block>
                        <Input value="Email" disabled style={{ width: 100 }} />
                        <Form.Item
                            name="email"
                            rules={[ { required: true, message: 'Email is required' } ]}
                            noStyle
                        >
                            <Input className="ts_padding" disabled={true} />
                        </Form.Item>
                    </Space.Compact>

                    <Space.Compact block>
                        <Input value="Code" disabled style={{ width: 100 }} />
                        <Form.Item
                            name="code"
                            rules={[ { required: true, message: 'Code is required' } ]}
                            noStyle
                        >
                            <Input className="ts_padding" disabled={pending} />
                        </Form.Item>
                    </Space.Compact>

                    <Space.Compact block>
                        <Input value="New Password" disabled style={{ width: 100 }} />
                        <Form.Item
                            name="password"
                            rules={[
                                { required: true, message: 'Password is required' },
                                {
                                    min: 10,
                                    message: 'Password must be at least 10 characters long.',
                                },
                                {
                                    pattern:  /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>\/?]).*$/,
                                    message: 'Password must include at least 1 uppercase letter, 1 number, and 1 special character.',
                                },
                            ]}
                            noStyle
                        >
                            <Input.Password autoComplete="new-password" className="ts_padding" disabled={pending} />
                        </Form.Item>
                    </Space.Compact>
                    <Space.Compact block>
                        <Input value="Confirm Password" disabled style={{ width: 100 }} />
                        <Form.Item
                            name="confirm_password"
                            dependencies={['password']}
                            rules={[
                                { required: true, message: 'Confirm Password is required' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Passwords do not match!'));
                                    },
                                }),
                            ]}
                            noStyle
                        >
                            <Input.Password autoComplete="new-password" className="ts_padding" disabled={pending} />
                        </Form.Item>
                    </Space.Compact>

                    <Divider />

                    <Button
                        type="primary"
                        htmlType="submit"
                        className="ts_margin_left"
                        loading={pending}
                        disabled={expiredCode}
                    >
                        Submit
                    </Button>

                    <Button
                        onClick={closeModal}
                        className="ts_margin_left"
                        disabled={pending}
                    >
                        Cancel
                    </Button>

                </Form>
            </Modal>
        }
    </>);
};



export default PasswordResetForm;
